export interface IntroducingBrokerProfileDto {
  id: string
  name: string
  description: string | null
  tickmillCompany: { id: number; name: string | null }
}

export enum IntroducingBrokerProfileKey {
  id = 'id',
  name = 'name',
  description = 'description',
  tickmillCompany = 'tickmillCompany.name',
  currency = 'currency.name',
  classificationType = 'classificationType.name',
}

export enum IntroducingBrokerProfileFilterKey {
  name = 'Name',
  tickmillCompany = 'TickmillCompanyId',
}
